// Limite único para os controles de margem: a soma com as taxas fica abaixo de 100%.
export function margemMaxima(taxaTotalPct = 0) {
  const taxa = Math.max(0, Number(taxaTotalPct) || 0);
  return Math.max(0, Math.min(99, Math.ceil(100 - taxa - 1e-8) - 1));
}

export function limitarMargem(valor, taxaTotalPct = 0) {
  const numero = Number(valor);
  return Math.min(margemMaxima(taxaTotalPct), Math.max(0, Number.isFinite(numero) ? numero : 50));
}

// Valores antigos acima de 99% não são interpretados como margem de venda.
export function margemPadraoValida(valor) {
  if (valor == null || String(valor).trim() === "") return "50";
  const numero = Number(valor);
  return Number.isFinite(numero) && numero >= 0 && numero <= 99 ? String(numero) : "50";
}
